export const CHANGE_ITEM_INTERVAL_SECONDS = 4;
